import React from 'react';
import DepositRow from './DepositRow';
import { ConvertPaymentTypeToView, PaymentMethods, PaymentPages } from './DepositService';
import WarningSvg from './assets/warning.svg';
import { getSvgIcon, NoMethods, DepositAddBreak, AddNew } from './DepositModal';

export const SavedPaymentTypes = ({
	userPaymentMethods,
	setSelectedPaymentType,
	selectedPaymentType,
	removePaymentTypeFromList,
	setCurrentPageIndex,
	previousCodes,
	viewBlueshyftCodes,
}) => {
	// get saved payment types and render them, handle selection
	const getTitleForRow = (paymentType: UserResponsePaymentTypes) => {
		if (paymentType.card?.label) return paymentType.card.label;
		return ConvertPaymentTypeToView(paymentType.deposit_request_type as any).name;
	};
	const isSelectedPaymentType = (paymentType: UserResponsePaymentTypes) => {
		if (selectedPaymentType?.deposit_request_type?.id === PaymentMethods.Card) {
			return paymentType?.card?.id === selectedPaymentType.card?.id;
		} else {
			return paymentType?.deposit_request_type?.id === selectedPaymentType?.deposit_request_type?.id;
		}
	};
	const onAddNewPress = () => {
		setCurrentPageIndex(PaymentPages.Select);
	};
	return (
		<>
			{userPaymentMethods && userPaymentMethods.length > 0 ? (
				userPaymentMethods?.map((paymentType: UserResponsePaymentTypes, index: number) => {
					const key =
						paymentType.deposit_request_type?.id !== PaymentMethods.Card
							? paymentType.deposit_request_type?.id
							: paymentType.card?.id;

					return (
						<DepositRow
							key={key}
							title={getTitleForRow(paymentType)}
							type="savedPayment"
							selected={isSelectedPaymentType(paymentType)}
							onClick={() => {
								setSelectedPaymentType(paymentType);
							}}
							onRemove={async () => await removePaymentTypeFromList(paymentType)}
							buttonFunction={
								paymentType?.deposit_request_type?.id === PaymentMethods.Cash &&
								previousCodes &&
								previousCodes?.length > 0
									? viewBlueshyftCodes
									: undefined
							}
							icon={getSvgIcon(paymentType)}
							isOnTop={index === 0}
						/>
					);
				})
			) : (
				<NoMethods>
					<img src={WarningSvg} alt="WARNING" />
					<p style={{ color: '#dde1e3' }}> No Payment methods added</p>
				</NoMethods>
			)}
			<DepositAddBreak />
			<AddNew onClick={() => onAddNewPress()}>
				<div>+ ADD NEW PAYMENT METHOD</div>
			</AddNew>
		</>
	);
};
